import React, { useState, useEffect } from 'react';
import { Switch } from 'react-router';
import Spinner from 'components/Spinner';
import API from 'helpers/API';
import AuthRoute from 'routes/Auth/AuthRoute';
import resources from 'constants/resources';
import ShipmentFilterContext from 'routes/Settings/ShipmentFilters/ShipmentFiltersContext';
import ShipmentFilterList from './ShipmentFilterList';
import ShipmentFilterPage from './ShipmentFilterPage';

const ShipmentFilters = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [shipmentEventFilters, setShipmentFilters] = useState([]);
  const [availableShipmentStates, setAvailableShipmentStates] = useState([]);
  const [carrierIntegrations, setCarrierIntegrations] = useState([]);
  const [metadataGroupings, setMetadataGroupings] = useState([]);
  const [customEventTypes, setCustomEventTypes] = useState([]);
  const [shipmentFilterExpiries, setShipmentFilterExpiries] = useState([]);
  const [smartFilterConfiguration, setSmartFilterConfiguration] = useState({});
  const [shipmentFiltersUpdated, setShipmentFiltersUpdated] = useState(false);

  const availableCalculatedEvents = [
    {
      id: '1',
      name: 'Late',
    },
    {
      id: '2',
      name: 'May Be Missing',
    },
  ];

  useEffect(() => {
    const loadData = async () => {
      setIsLoading(true);
      try {
        await Promise.all([
          API.getShipmentFilters().then(response => setShipmentFilters(response.shipment_filters)),
          API.getAvailableShipmentStates().then(response => setAvailableShipmentStates(response.shipment_states)),
          API.getCarrierIntegrations().then(response => setCarrierIntegrations(response)),
          API.getShipmentMetadataGroupings().then(response => setMetadataGroupings(response.groupings)),
          API.getCustomEventTypes().then(response => setCustomEventTypes(response.customEventTypes)),
          API.getShipmentFilterExpiries().then(response => setShipmentFilterExpiries(response.shipment_filter_expiry_items)),
          API.getSmartFilterConfiguration().then(response => setSmartFilterConfiguration(response)),
        ]);
      } finally {
        setIsLoading(false);
        setShipmentFiltersUpdated(false);
      }
    };

    loadData();
  }, [shipmentFiltersUpdated]);

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <ShipmentFilterContext.Provider value={{
      shipmentEventFilters,
      availableShipmentStates,
      carrierIntegrations,
      metadataGroupings,
      customEventTypes,
      shipmentFilterExpiries,
      smartFilterConfiguration,
      shipmentFiltersUpdated,
      availableCalculatedEvents,
      setShipmentFiltersUpdated,
    }}
    >
      <Switch>
        <AuthRoute exact path="/settings/shipment-filters" component={ShipmentFilterList} resource={resources.shipmentFilters.read} />
        <AuthRoute exact path="/settings/shipment-filters/create" component={ShipmentFilterPage} resource={resources.shipmentFilters.edit} />
        <AuthRoute exact path="/settings/shipment-filters/:shipmentFilterId" component={ShipmentFilterPage} resource={resources.shipmentFilters.edit} />
      </Switch>
    </ShipmentFilterContext.Provider>
  );
};

export default ShipmentFilters;
